<template>
  <question-card @submit="submit" :buttonText="UIComponentData.Button.Translations[questionnaireLead.Language]">
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <div>
        <v-select
        outlined
          v-model="questionnaireLead.EmploymentStatus"
          ref="input"
          :label="UIComponentData.InputPlaceholder1.Translations[questionnaireLead.Language]"
          :items="computedItems"
          required
      />
    </div>
  </question-card>
</template>

<script>
import QuestionCard from '@/components/QuestionCard.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'current-job-or-role-step',
  components: {
    QuestionCard,
  },
  methods: {
    ...mapActions(['mutateLead']),
    async submit() {
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
    computedItems(){
      return this.UIComponentData.Choices.map(element => {
        return element.Translations[this.questionnaireLead.Language]
      });
    }
  },
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  created(){
    if(!this.questionnaireLead.EmploymentStatus)
      this.$set(this.questionnaireLead, 'EmploymentStatus','');
  }
};
</script>
<style scoped lang="scss">
::v-deep .v-select__selections{
  justify-content: center;
  .v-select__selection{
    flex: 1;
    text-align: center;
  }
  input{
    flex: 0 !important;
  }
}
</style>